import Home from '@/views/backend/Home'
import SignIn from '@/views/backend/SignIn'
import ForgetPassword from '@/views/backend/ForgetPassword'
import SignUp from '@/views/backend/SignUp'
import AccountVerify from "@/views/backend/AccountVerify"
import OtpCode from "@/views/backend/OtpCode";
import CreateNewPwd from "@/views/backend/CreateNewPwd";
import Dashboard from "@/views/backend/dashboard/Dashboard"
import AgentPending from "@/views/backend/dashboard/Pending"
import AgentApproved from "@/views/backend/dashboard/Approved"
import AgentDeclined from "@/views/backend/dashboard/Declined"
import ShowApproveDocView from "@/views/backend/dashboard/showApproveDoc"
import SignatureCertificate from "@/views/backend/dashboard/SignatureCertificate";

import TemplateList from "@/views/backend/Templates/List";
import TemplateCreate from "@/views/backend/Templates/Create";
import TemplateDocumentCreate from "@/views/backend/Templates/Document";
import TemplateEdit from "@/views/backend/Templates/Edit";
import TemplateView from "@/views/backend/Templates/DocumentView";

import ActivityLog from "@/views/backend/ActivityLog/index"
import ProfileView from "@/views/backend/Profile/index";
import ActivityReport  from "@/views/backend/ActivityReport";
import EnvelopeStatuReport from "@/views/backend/EnvelopeStatusReport";

import PendingView from "@/views/backend/Pending/index";
import CompletedView from "@/views/backend/Completed/index";
import Declined from "@/views/backend/Declined/index";
import Expired from "@/views/backend/Expired/index";
import AssignToMe from "@/views/backend/AssignTome/index";
import TemplateInternalStaff from "@/views/backend/TemplateList/index"
import AllDocuments from "@/views/backend/All/index"

import ViewDocument from "@/components/backend/ViewDocument";

var prefix = '/agent'
export default [
    {
        path:'/',
        name:'home',
        component:Home
    },

    {
        path:prefix+'/signin',
        name:'agentSignin',
        component:SignIn
    },

    {
        path:prefix+'/forget-password',
        name:'agentForgetPwd',
        component:ForgetPassword
    },

    {
        path:prefix+'/signup',
        name:'agentSignup',
        component:SignUp
    },

    {
        path:prefix+'/accountverify',
        name:'agentAccVerify',
        component:AccountVerify
    },

    {
        path:prefix+'/otpcode',
        name:'agentOtpCode',
        component:OtpCode
    },

    {
        path: prefix+'/createnewpassword',
        name: 'agentCreateNewPWD',
        component: CreateNewPwd
    },

    {
        path: prefix+'/dashboard',
        name: 'agentDashboard',
        component:Dashboard
    },

    {
        path:prefix+'/dashboard/pending',
        name:'agentPending',
        component: AgentPending
    },

    {
        path: prefix+'/dashboard/approved',
        name:'agentApproved',
        component:AgentApproved
    },

    {
        path: prefix+'/dashboard/declined',
        name: 'agentDeclined',
        component: AgentDeclined
    },


    {
        path:   prefix+'/approveddocumentview/:document_id',
        name : 'agentApproveDocView',
        component:ShowApproveDocView,
    },

    {
        path: prefix+'/dashboard/signatureCertificate/:id',
        name: 'signatureCertificate',
        component: SignatureCertificate
    },

    {
        path:prefix+'/template/list',
        name:'templateList',
        component: TemplateList
    },

    {
        path:prefix+'/template/create',
        name:'templateCreate',
        component: TemplateCreate
    },

    {
        path:prefix+'/template/documentCreate/:id',
        name:'documentCreate',
        component: TemplateDocumentCreate
    },

    {
        path:prefix+'/template/edit/:id',
        name:'templateEdit',
        component: TemplateEdit
    },

    {
        path:prefix+'/template/view/:id',
        name:'templateView',
        component: TemplateView
    },

    {
        path:prefix+'/activitylog/view',
        name:'activityLog',
        component: ActivityLog
    },

    {
        path:prefix+'/profile/view',
        name:'profileView',
        component: ProfileView
    },

    {
        path:prefix+'/activityReport',
        name:'activityReportView',
        component: ActivityReport
    },

    {
        path:prefix+'/envelopeStatusReport',
        name:'envelopeStatusReportView',
        component: EnvelopeStatuReport
    },

    //dashboard sidebar list
    {
        path:prefix+'/pending',
        name:'PendingView',
        component: PendingView
    },

    {
        path:prefix+'/completed',
        name:'CompletedView',
        component: CompletedView
    },

    {
        path:prefix+'/declined',
        name:'declinedView',
        component: Declined
    },

    {
        path:prefix+'/expired',
        name:'expiredView',
        component: Expired
    },

    {
        path:prefix+'/assignToMe',
        name:'assignToMeView',
        component: AssignToMe
    },

    {
        path:prefix+'/templateList',
        name:'templateListView',
        component: TemplateInternalStaff
    },

    {
        path:prefix+'/allDocuments',
        name:'allDocumentsView',
        component: AllDocuments
    },

    {
        path:   prefix+'/dashboard/documentview/:document_id',
        name : 'documentView',
        component:ViewDocument,
    },


]
